import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { SinglePropertyStore } from '../stores';

export const useSinglePropertyStore = () => useContext<{
  singlePropertyStore: SinglePropertyStore
}>(StoreContext);
